let wishlistCount = document.querySelectorAll(".wishlist-count");
let wishlistPageWrapper = document.querySelector(".wishlist_page_wrapper");
let wishlistContainer = document.querySelector(".wishlist_container");
let wishlistHeader = document.querySelector(".wishlist_header");

async function waitForCustomerId() {
  return new Promise((resolve) => {
    let checkInterval = setInterval(() => {
      if (typeof SWGetCustomerWishlistId === "function") {
        let customerId = SWGetCustomerWishlistId();
        if (customerId && customerId !== 0) {
          clearInterval(checkInterval);
          resolve(customerId);
        }
      }
    }, 100);
  });
}

async function fetchWishlist() {
  let customerId = await waitForCustomerId();

  if (wishlistContainer) {
    wishlistContainer.innerHTML = "<div class='loading_text'>Loading...</div>";
    wishlistContainer.style.display = "block";
    wishlistContainer.style.textAlign = "center";
  }

  try {
    const response = await fetch(
      `https://thebearhouse.com/a/wishlist?type=api&customerid=${customerId}&version=1`
    );

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();

    wishlistCount.forEach((item) => {
      item.textContent = data.count;
    });

    // Clear existing wishlist content
    if (wishlistContainer) {
      wishlistContainer.innerHTML = "";
    }

    // Check if the wishlist is empty
    if (data.count === 0 && wishlistContainer) {
      wishlistHeader.style.display = "none";
      wishlistContainer.innerHTML =
        "<div class='empty_text'>Your Wishlist is Empty</div>";
      wishlistContainer.style.display = "block";
    } else {
      if (wishlistContainer) {
        wishlistContainer.style.display = "grid";
      }
      // Populate the wishlist with data using template literals
      data.items.forEach((item) => {
        const wishlistItem = `
            <a href="/products/${item.handle}" class="wishlist_card">
              <div class="wishlist_image">
                <img src="${item.image}" alt="${item.title}" width="200" height="200">
              </div>
              <div class="content grid-product__meta">
              <div class="grid-product__title">${item.title}</div>
              <div class="grid-product__vender">${item.vendor}</div>
                <div class="grid-product__price">Rs.${item.variant_price}</div>
              </div>
            </a>
          `;
        if (wishlistContainer) {
          wishlistContainer.innerHTML += wishlistItem;
        }
      });
    }
  } catch (error) {
    console.error("Error fetching wishlist:", error);
    if (wishlistContainer) {
      wishlistContainer.innerHTML =
        "<div class='error_text'>Failed to load wishlist. Please try again later.</div>";
    }
  }
}


fetchWishlist();
document.addEventListener("wishlist:updated", fetchWishlist);
